
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteR as ObiOwnShipRemoteRElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-r.js';
 
 
 

 
 export const ObiOwnShipRemoteR = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-r',
   elementClass: ObiOwnShipRemoteRElement,
   events: {
     
   }
  });
 
 